module.exports = __webpack_public_path__ + "img/farming_3.1e2d0834.png";